var map = {
	"./addBlack.svg": [
		1195,
		3
	],
	"./addWhite.svg": [
		1196,
		4
	],
	"./add_assignee.svg": [
		1197,
		5
	],
	"./additional.svg": [
		1198,
		6
	],
	"./asset.svg": [
		1199,
		7
	],
	"./assistant-blue.svg": [
		1200,
		8
	],
	"./assistant-grey.svg": [
		1201,
		9
	],
	"./attach.svg": [
		1202,
		10
	],
	"./bot.svg": [
		1203,
		11
	],
	"./camera.svg": [
		1204,
		12
	],
	"./cancel.svg": [
		1205,
		13
	],
	"./cancelOrder.svg": [
		1206,
		14
	],
	"./chat.svg": [
		1207,
		15
	],
	"./checklist.svg": [
		1208,
		16
	],
	"./client-comments.svg": [
		1209,
		17
	],
	"./client-delete.svg": [
		1210,
		18
	],
	"./confirmOrder.svg": [
		1211,
		19
	],
	"./content.svg": [
		1212,
		20
	],
	"./dashboard.svg": [
		1213,
		21
	],
	"./delete.svg": [
		1214,
		22
	],
	"./delivered.svg": [
		1215,
		23
	],
	"./diesel.svg": [
		1216,
		24
	],
	"./document.svg": [
		1217,
		25
	],
	"./edit-pencil.svg": [
		1218,
		26
	],
	"./energy.svg": [
		1219,
		27
	],
	"./enter.svg": [
		1220,
		28
	],
	"./expand.svg": [
		1221,
		29
	],
	"./gallery.svg": [
		1222,
		30
	],
	"./generateInvoice.svg": [
		1223,
		31
	],
	"./grey-right-arrow.svg": [
		1224,
		32
	],
	"./headcount.svg": [
		1225,
		33
	],
	"./import.svg": [
		1226,
		34
	],
	"./in progress.svg": [
		1227,
		35
	],
	"./instructions.svg": [
		1228,
		36
	],
	"./inventory.svg": [
		1229,
		37
	],
	"./invoice.svg": [
		1230,
		38
	],
	"./leftArr-blue.svg": [
		1231,
		39
	],
	"./leftArr-grey.svg": [
		1232,
		40
	],
	"./location.svg": [
		1233,
		41
	],
	"./locations.svg": [
		1234,
		42
	],
	"./mappingPeople.svg": [
		1235,
		43
	],
	"./message.svg": [
		1236,
		44
	],
	"./meter.svg": [
		1237,
		45
	],
	"./meters.svg": [
		1238,
		46
	],
	"./new-message.svg": [
		1239,
		47
	],
	"./people.svg": [
		1240,
		48
	],
	"./ppm.svg": [
		1241,
		49
	],
	"./prescription.svg": [
		1242,
		50
	],
	"./purchase_order.svg": [
		1243,
		51
	],
	"./qr.svg": [
		1244,
		52
	],
	"./qrCode.svg": [
		1245,
		53
	],
	"./refresh.svg": [
		1246,
		54
	],
	"./reminder-bell.svg": [
		1247,
		55
	],
	"./report.svg": [
		1248,
		56
	],
	"./right-arrow.svg": [
		1249,
		57
	],
	"./rightArr-blue.svg": [
		1250,
		58
	],
	"./rightArr-grey.svg": [
		1251,
		59
	],
	"./rules.svg": [
		1252,
		60
	],
	"./sales.svg": [
		1253,
		61
	],
	"./search.svg": [
		1254,
		62
	],
	"./selectedBot.svg": [
		1255,
		63
	],
	"./selectedChat.svg": [
		1256,
		64
	],
	"./selectedContent.svg": [
		1257,
		65
	],
	"./selectedDashboard.svg": [
		1258,
		66
	],
	"./send_message.svg": [
		1259,
		67
	],
	"./set_date.svg": [
		1260,
		68
	],
	"./shrink.svg": [
		1261,
		69
	],
	"./star.svg": [
		1262,
		70
	],
	"./tick.svg": [
		1263,
		71
	],
	"./tick_grey.svg": [
		1264,
		72
	],
	"./timer.svg": [
		1265,
		73
	],
	"./user.svg": [
		1266,
		74
	],
	"./vendor.svg": [
		1267,
		75
	],
	"./workorder.svg": [
		1268,
		76
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 829;
module.exports = webpackAsyncContext;